const gen = (count) => {
    let out = ''
    for (let index = 0; index < count; index++) {
        out += (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
    }
    return out
}

export default () => [gen(2), gen(1), gen(1), gen(1), gen(3)].join('-')
